export class SetObjectState {
  static readonly type = '[Document] Set Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[Document] Reset State';
  constructor() {}
}

export class PrepareRequest {
  static readonly type = '[Document] Prepare Request';
  constructor(public tranOptions: any) {}
}

export class UpdateDocument {
  static readonly type = '[Document] Update Document';
  constructor(public document: any) {}
}

export class UpdateFiling {
  static readonly type = '[Document.Filing] Update Filing';
  constructor(public filing: any) {}
}

export class AddFiling {
  static readonly type = '[Document.Filing] Add Filing';
  constructor(public filing: any) {}
}

export class DeleteNewFilings {
  static readonly type = '[Document.Filing] Delete New Filings';
  constructor() {}
}

export class UpdateFilingReferences {
  static readonly type = '[Document.Filing] Update Filing References';
  constructor(public filingTemplate: any) {}
}

export class NewDocument {
  static readonly type = '[Document] New Document';
  constructor(public documentDefaults: any) {}
}

export class SetDefaultDrawerFolder {
  static readonly type = '[Document] Set Default File Drawer and Folder';
  constructor(public defaults: any, public updateFilings: boolean) {}
}
